<template>
  <div style="width:100%;height:auto; margin:0 auto;">
    <el-form ref="form" :model="form" label-width="80px">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item>
            <div slot="label">发布类型</div>
            <el-select v-model="form.type" clearable style="width:100%;" disabled>
              <el-option v-for="item in types" :key="item.code" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form-item>
            <div slot="label">发布标题</div>
            <el-input v-model.trim="form.title" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item>
            <div slot="label">发布日期</div>
            <el-date-picker v-model="form.fabuTime" type="date" value-format="yyyy-MM-dd" style="width:100%;" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="上传文件">
        <el-upload
          action=""
          class="upload-demo"
          :file-list="fileList"
          :on-preview="handleProgress"
          name="uploadfile_ant"
          disabled
        >
          <el-button class="filter-item" type="primary" icon="el-icon-download" @click="onButtonDownload(fileList)">文件下载</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="发布内容">
        <el-card class="box-card" style="overflow-y: scroll;">
          <div class="markdown-body" v-html="form.neiRong" />
        </el-card>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getInfo } from '@/api/baseRelease'
import { downloadById } from '@/api/baseReleaseFile'
import { getDictListByCode } from '@/api/dict'

import 'github-markdown-css'

export default {
  name: 'FuncFormsEdit',
  inject: ['getList'],
  props: {
    proid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      types: [],
      form: {
        id: '',
        title: '',
        type: '',
        neiRong: '',
        fabuTime: ''
      },
      code: ''
    }
  },
  created() {
    this.getDictEntry('YW_RELEASE_TYPE')
  },
  methods: {
    getDictEntry(code) {
      getDictListByCode(code).then(response => {
        if (code === 'YW_RELEASE_TYPE') {
          this.types = response.data
        }
      })
    },
    getDetailed() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getInfo({ code: this.proid }).then(response => {
        this.form = response.data.baseRelease

        this.fileList = response.data.fileList1.map(item => {
          return {
            name: item.originalName,
            url: item.url,
            fileId: item.id
          }
        })

        loading.close()
      }).catch(function() {
        loading.close()
      })
    },
    // 文件下载
    onButtonDownload(file) {
      downloadById({ id: file[0].fileId }).then(response => {
        var fileName = file[0].name
        const contentDisposition = response.headers['content-disposition']
        if (contentDisposition) {
          fileName = window.decodeURI(response.headers['content-disposition'].split('=')[1], 'UTF-8')
        }
        const blob = new Blob([response.data], {
          type: `*`
        })
        const objectUrl = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    }
  }
}
</script>

<style lang="scss">
.collapse-title{
  font-size: 16px;
  color:#1196EE;
}
.el-input.is-disabled .el-input__inner {
    background-color: #F5F7FA !important;
    color: #000 !important;
    cursor: not-allowed;
}
.el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #dfe4ed;
    color: #000000;
    cursor: not-allowed;
}
</style>

